import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CommercialListRequestBody, CommercialListResponse } from "./types";

export class CommercialListAPI extends BaseAPI<
    CommercialListRequestBody,
    CommercialListResponse
> {
    protected route = ApiRoutes.property.commercial;
    protected method = RequestMethod.GET;
    // No params array - all parameters should be query parameters
} 